module.exports = __webpack_public_path__ + "static/mentor-archana-deb50479c847bacc0a45488e5cb02897.jpg";